import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ButtonModule } from 'primeng/button';
import { MenubarModule } from 'primeng/menubar';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { MultiSelectModule } from 'primeng/multiselect';
import { ChipModule } from 'primeng/chip';
import { TableModule } from 'primeng/table';
import { TabViewModule } from 'primeng/tabview';
import { DropdownModule } from 'primeng/dropdown';
import { SidebarModule } from 'primeng/sidebar';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { SelectButtonModule } from 'primeng/selectbutton';
import { DialogModule } from 'primeng/dialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ProgressBarModule } from 'primeng/progressbar';
import { TimelineModule } from 'primeng/timeline';
import { CheckboxModule } from 'primeng/checkbox';
import { SkeletonModule } from 'primeng/skeleton';
import { CalendarModule } from 'primeng/calendar';
import { ImageModule } from 'primeng/image';
import { EditorModule } from 'primeng/editor';
import { AccordionModule } from 'primeng/accordion';
import { ToastModule } from 'primeng/toast';
import { AvatarModule } from 'primeng/avatar';
import { RatingModule } from 'primeng/rating';
import { BadgeModule } from 'primeng/badge';
import { InputSwitchModule } from 'primeng/inputswitch';
import { FieldsetModule } from 'primeng/fieldset';
import { FileUploadModule } from 'primeng/fileupload';
import { CardModule } from 'primeng/card';
import { DataViewModule } from 'primeng/dataview';
import { GalleriaModule } from 'primeng/galleria';
import { TooltipModule } from 'primeng/tooltip';
import { MessagesModule } from 'primeng/messages';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { PanelModule } from 'primeng/panel';
import { ListboxModule } from 'primeng/listbox';
import { InputNumberModule } from 'primeng/inputnumber';
import { TagModule } from 'primeng/tag';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { PaginatorModule } from 'primeng/paginator';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonModule,
    MenubarModule,
    InputTextModule,
    ToolbarModule,
    MultiSelectModule,
    ChipModule,
    TableModule,
    TabViewModule,
    DropdownModule,
    SidebarModule,
    InputTextareaModule,
    SelectButtonModule,
    DialogModule,
    OverlayPanelModule,
    ConfirmPopupModule,
    RadioButtonModule,
    SplitButtonModule,
    ProgressBarModule,
    TimelineModule,
    CheckboxModule,
    SkeletonModule,
    CalendarModule,
    ImageModule,
    EditorModule,
    AccordionModule,
    ToastModule,
    AvatarModule,
    RatingModule,
    BadgeModule,
    InputSwitchModule,
    FieldsetModule,
    FileUploadModule,
    CardModule,
    DataViewModule,
    GalleriaModule,
    TooltipModule,
    MessagesModule,
    ConfirmDialogModule,
    PanelModule,
    ListboxModule,
    InputNumberModule,
    TagModule,
    ProgressSpinnerModule,
    PaginatorModule,
  ],
  exports: [
    ButtonModule,
    MenubarModule,
    InputTextModule,
    ToolbarModule,
    MultiSelectModule,
    ChipModule,
    TableModule,
    TabViewModule,
    DropdownModule,
    SidebarModule,
    InputTextareaModule,
    SelectButtonModule,
    DialogModule,
    OverlayPanelModule,
    ConfirmPopupModule,
    RadioButtonModule,
    SplitButtonModule,
    ProgressBarModule,
    TimelineModule,
    CheckboxModule,
    SkeletonModule,
    CalendarModule,
    ImageModule,
    EditorModule,
    AccordionModule,
    ToastModule,
    AvatarModule,
    RatingModule,
    BadgeModule,
    InputSwitchModule,
    FieldsetModule,
    FileUploadModule,
    CardModule,
    DataViewModule,
    GalleriaModule,
    TooltipModule,
    MessagesModule,
    ConfirmDialogModule,
    PanelModule,
    ListboxModule,
    InputNumberModule,
    TagModule,
    ProgressSpinnerModule,
    PaginatorModule,
  ],
})
export class PrimengModule {}
